import { render } from "./DocumentRowGroup.vue?vue&type=template&id=67139cdc"
import script from "./DocumentRowGroup.vue?vue&type=script&lang=js"
export * from "./DocumentRowGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__